import React from 'react';
import Form from 'react-bootstrap/Form';  

const Processincome = () => {
  return (
    <div>

<div className="col-lg-6 m-3">
                  <div className="card border-0 shadow ">
                    <div className="card-header bg bg-info border-0">
                      <h4>Process Income</h4>
                    </div>

                    <div className="card-body">
                      

                      <div className="col-lg-12 mt-3">
                        <label for="exampleInputPassword1" class="form-label">
                        Edit Cash back Income
                        </label>
                        <input
                          type="password"
                          class="form-control"
                          placeholder="Confirm Password"
                          id="exampleInputPassword1"
                        />
                      </div>
                     

                      <div className="col-lg-12 mt-3">
                        <button className="btn btn-primary">Submit</button>
                      </div>
                    </div>
                  </div>
    </div>


    </div>
  )
}

export default Processincome;